import { makeStyles } from '@material-ui/core'
import { colors } from '../../Themes'

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: colors.white,
    boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
    padding: 20,
    outline: 'none',
    borderRadius: 10,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 320,
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: 550,
    },
  },
  backdrop: {
    backgroundColor: colors.primaryRGBA(0.5),
  },
  noBlur: {
    backgroundColor: colors.primaryRGBA(0.5),
  },
}))

export default useStyles